import React, { useState } from "react";

/**
 * Image with a pulsing skeleton placeholder shown until the image loads.
 * - skeletonShape: "circle" (default — for tires) or "rect"
 * - className wraps both skeleton and image, so callers can size the box.
 */
export const TireImage = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  skeletonShape = "circle",
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative ${className}`}>
      {!loaded && (
        <div
          aria-hidden="true"
          data-testid="image-skeleton"
          className={`absolute inset-0 skeleton-pulse ${
            skeletonShape === "circle" ? "rounded-full" : ""
          }`}
        />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className={`relative transition-opacity duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        } ${imgClassName}`}
      />
    </div>
  );
};

export default TireImage;
